(() => {
  if (window.BTTSectionScrollCarousel) return;

  const initializeCarousel = (section) => {
    if (!section || section.dataset.carouselInitialized === 'true') return;

    const trackSelector = section.dataset.carouselTrack;
    const dotSelector = section.dataset.carouselDot;
    const track = trackSelector ? section.querySelector(trackSelector) : null;
    const slides = Array.from(track?.children || []);
    const dots = dotSelector ? Array.from(section.querySelectorAll(dotSelector)) : [];

    if (!track || !slides.length || !dots.length) return;
    section.dataset.carouselInitialized = 'true';

    const setActiveDot = (index) => {
      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    const centeredScrollPosition = (slide) =>
      slide.offsetLeft - track.offsetLeft - (track.clientWidth - slide.clientWidth) / 2;

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        track.scrollTo({ left: centeredScrollPosition(slides[index]), behavior: 'smooth' });
        setActiveDot(index);
      });
    });

    let scrollFrame;
    track.addEventListener(
      'scroll',
      () => {
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(() => {
          const currentPosition = track.scrollLeft + track.clientWidth / 2;
          const activeIndex = slides.reduce((closestIndex, slide, index) => {
            const closestCenter =
              slides[closestIndex].offsetLeft - track.offsetLeft + slides[closestIndex].clientWidth / 2;
            const slideCenter = slide.offsetLeft - track.offsetLeft + slide.clientWidth / 2;

            return Math.abs(slideCenter - currentPosition) < Math.abs(closestCenter - currentPosition)
              ? index
              : closestIndex;
          }, 0);

          setActiveDot(activeIndex);
        });
      },
      { passive: true }
    );

    requestAnimationFrame(() => {
      track.scrollLeft = centeredScrollPosition(slides[0]);
    });
  };

  const initializeWithin = (container = document) => {
    if (container.matches?.('[data-section-carousel]')) initializeCarousel(container);
    container.querySelectorAll?.('[data-section-carousel]').forEach(initializeCarousel);
  };

  window.BTTSectionScrollCarousel = { initializeWithin };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWithin());
  } else {
    initializeWithin();
  }

  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
})();
